import React, {useEffect, useState} from "react";
import axios from "axios";
import {
    CircularProgress,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Pagination,
    Paper,
    Tooltip,
    Button,
} from "@mui/material";
import "./OldObjects.css";
import {MdOpenInNew, MdOutlineCleaningServices} from "react-icons/md";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import CustomAlert from "../../../components/ConfirmationModal/CustomAlert";
import {jwtDecode} from "jwt-decode";
import {useNavigate} from "react-router-dom";
import {IoMdTrash} from "react-icons/io";
import {AiOutlineSearch} from "react-icons/ai";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearch} from "@fortawesome/free-solid-svg-icons";

const OldObjects = () => {
    const [data, setData] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [isDeleteConfirmModalOpen, setIsDeleteConfirmModalOpen] = useState(false);
    const [page, setPage] = useState(1);
    const [isCleared, setIsCleared] = useState(false);
    const [totalPages, setTotalPages] = useState(0);
    const [currentObjectId, setCurrentObjectId] = useState(null);
    const [alert, setAlert] = useState({message: '', severity: 'info'});
    const [userRole, setUserRole] = useState('');
    const [searchQuery, setSearchQuery] = useState("");
    const [isUserRoleSet, setIsUserRoleSet] = useState(false);
    const [isVisibleOnMap, setIsVisibleOnMap] = useState(null);
    const navigate = useNavigate();
    const token = localStorage.getItem('jwtToken');
    const dataKeys = [
        'ობიექტის დასახელება',
        'საიდენტიფიკაციო მონაცემები',
        'რეგისტრაციის თარიღი',
        'ობიექტის მფლობელის დასახელება',
        'კომენტარი',
        'ობიექტის მწარმოებელი',
        'რეგისტრაციის ნომერი',
        'ინსპექტირების თარიღი',
        'სამმართლებრივი რეაგირება / სანქცია',
        'რეგიონი',
        'მომდევნო ინსპექტირების თარიღი',
        'ინფორმაცია ობიექტზე მომხადარი ავარიის და უბედური შემთხვევაში შესახებ',
        'ობიექტის ნებართვის ნომერი ან შესაბამისი აქტის ნომერი',
        'შენიშვნა',
        'ობიექტის ძირითადი ტექნიკური მახასიათებლები',
        'მისამართი',
        'ობიექტის ნებართვის ნომერი ან აქტის ნომერი',
        'უწყებრივ რეესტრში რეგისტრაციის ნომერი'
    ]


    useEffect(() => {
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setUserRole(decoded.role);
            } catch (error) {
                setUserRole("");
            } finally {
                setIsUserRoleSet(true);
            }
        }
    }, [token]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const requestBody = {
                searchByLikeStr: searchQuery,
                dataKey: dataKeys,
                page: page,
                filTerByObjectIsOnTheMap: isVisibleOnMap,
                pageSize: 10
            };

            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllTacsaOld`, requestBody);
            setData(response.data.data.result === null ? [] : response.data.data.result);
            setTotalCount(response.data.data.totalCount);
            setTotalPages(Math.ceil(response.data.data.totalCount / 10));
        } catch (error) {
            console.error("Error fetching data:", error);
        }
        setLoading(false);
    };


    const handleSearch = () => {
        setPage(1);
        void fetchData();
    };

    const clearFilters = () => {
        setPage(1);
        setIsVisibleOnMap(null);
        setIsCleared(true);
        setSearchQuery("");
    };

    useEffect(() => {
        if (isCleared) {
            void fetchData().then(() => setIsCleared(false));
        }
    }, [isCleared]);


    const handleDeleteConfirm = async () => {
        setIsDeleteConfirmModalOpen(false);
        const payload = {
            id: parseInt(currentObjectId),
        };
        try {
            await axios.put(`${process.env.REACT_APP_API_BASE_URL}/DeleteTacsaOld`, payload);
            setAlert({message: 'ოპერაცია წარმატებით დასრულდა', severity: 'success'});
            await fetchData();
        } catch (error) {
            setAlert({message: 'დაფიქსირდა შეცდომა', severity: 'error'});
        }

    };

    const openObject = (id) => {
        window.open(`createexpercase?id=${id}`, '_blank');
    };

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const pageFromUrl = parseInt(queryParams.get("page"));
        setPage(pageFromUrl || 1); // Default to 1 if no page is specified in the URL
    }, []);


    const handlePageChange = (event, value) => {
        setPage(value);
        const queryParams = new URLSearchParams(window.location.search);
        queryParams.set("page", value);
        navigate(`?${queryParams.toString()}`, {replace: true});
    };

    useEffect(() => {
        void fetchData();
    }, [page, userRole, isUserRoleSet, token]);

    return (
        <div className="table-container">
            {loading ? (
                <div className="old-objects-loader">
                    <CircularProgress/>
                </div>
            ) : (
                <div>
                    <div className="old-objects-total-container">
                        <div className="old-objects-title">ძველი უწყებრივი რეესტრის ობიექტები</div>
                        <div className="old-objects-total-box">
                            ნაპოვნია: {totalCount}
                        </div>
                    </div>
                    <div className="old-objects-search">
                        <div style={{display: 'flex', gap: 10, marginTop: 15}}>
                            <input
                                type="text"
                                placeholder="ძებნა"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                style={{
                                    flex: 1,
                                    padding: '8px 12px',
                                    border: '1px solid #ccc',
                                    borderRadius: 4,
                                    outline: 'none',
                                    fontSize: 14,
                                }}
                            />
                            <select
                                value={isVisibleOnMap ?? ''}
                                onChange={(e) => setIsVisibleOnMap(
                                    e.target.value === 'true' ? true : e.target.value === 'false' ? false : null
                                )}
                                style={{
                                    flex: 1,
                                    padding: '8px 12px',
                                    border: '1px solid #ccc',
                                    borderRadius: 4,
                                    outline: 'none',
                                    fontSize: 14,
                                    backgroundColor: '#fff',
                                    cursor: 'pointer',
                                }}
                            >
                                <option value="">დატანილია რუკაზე</option>
                                <option value="true">კი</option>
                                <option value="false">არა</option>
                            </select>
                        </div>


                        <div style={{display: 'flex', gap: 10, marginTop: 15}}>
                            <Button fullWidth variant="contained" onClick={handleSearch} endIcon={<AiOutlineSearch/>}>
                                ძებნა
                            </Button>
                            <Button fullWidth color="error" variant="contained" onClick={clearFilters}
                                    endIcon={<MdOutlineCleaningServices/>}>
                                ფილტრების წაშლა
                            </Button>
                        </div>
                    </div>

                    {data.length === 0 ? (
                            <div>
                                <div style={{width: '100%'}} className="nothing-found-message">
                                    <FontAwesomeIcon icon={faSearch} size="3x"/>
                                    <p>არაფერი მოიძებნა!</p>
                                </div>
                            </div> ) : (
                        <TableContainer component={Paper} className="old-objects-table">
                            <Table>
                                <TableHead className="old-objects-header">
                                    <TableRow>
                                        <TableCell className="old-objects-cell">რეგისტრაციის ნომერი</TableCell>
                                        <TableCell className="old-objects-cell">ობიექტის დასახელება</TableCell>
                                        <TableCell className="old-objects-cell">საიდენტიფიკაციო მონაცემები</TableCell>
                                        <TableCell className="old-objects-cell">რეგისტრაციის თარიღი</TableCell>
                                        <TableCell className="old-objects-cell">მფლობელი</TableCell>
                                        <TableCell className="old-objects-cell">ობიექტის ძირითადი ტექნიკური
                                            მახასიათებლები</TableCell>
                                        <TableCell className="old-objects-cell">რეგიონი</TableCell>
                                        <TableCell className="old-objects-cell">კომენტარი</TableCell>
                                        <TableCell className="old-objects-cell">ობიექტის მწარმოებელი</TableCell>
                                        <TableCell className="old-objects-cell">ინსპექტირების თარიღი</TableCell>
                                        <TableCell className="old-objects-cell">სამმართლებრივი რეაგირება /
                                            სანქცია</TableCell>
                                        <TableCell className="old-objects-cell">მომდევნო ინსპექტირების თარიღი</TableCell>
                                        <TableCell className="old-objects-cell">ინფორმაცია ობიექტზე მომხდარი ავარიის და
                                            უბედური შემთხვევის შესახებ</TableCell>
                                        <TableCell className="old-objects-cell">ობიექტის ნებართვის ნომერი ან შესაბამისი
                                            აქტის ნომერი</TableCell>
                                        <TableCell className="old-objects-cell">შენიშვნა</TableCell>
                                        <TableCell align="center"
                                                   style={{
                                                       position: 'sticky',
                                                       right: 0,
                                                       zIndex: 2,
                                                       borderRadius: 5,
                                                       backgroundColor: '#F4F4F4'
                                                   }}
                                                   className="old-objects-cell">
                                            ქმედება
                                        </TableCell>

                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {data.map((item) => (
                                        <TableRow  className="old-objects-row" onClick={() => openObject(item.id)}
                                                  key={item.id}>
                                            <TableCell align={'center'} className="old-objects-cell">{item.registraciis_N}</TableCell>
                                            <TableCell
                                                className="old-objects-cell">{item.obieqtis_Dasaxeleba}</TableCell>
                                            <TableCell
                                                className="old-objects-cell">{item.saidentifikacio_Nomeri}</TableCell>
                                            <TableCell
                                                className="old-objects-cell">{item.registraciis_Tarigi}</TableCell>
                                            <TableCell className="old-objects-cell">{item.obieqtis_Mflobeli}</TableCell>
                                            <TableCell
                                                className="old-objects-cell">{item.obieqtis_Dziritadi_Teqnikuri_Maxasiateblebi}</TableCell>
                                            <TableCell className="old-objects-cell">{item.raioni}</TableCell>
                                            <TableCell className="old-objects-cell">{item.komentari}</TableCell>
                                            <TableCell
                                                className="old-objects-cell">{item.obieqtis_Mwarmoebeli_Mshenebeli}</TableCell>
                                            <TableCell
                                                className="old-objects-cell">{item.chatarebuli_Inspeqtirebis_Tarigi_da_Dargvevis_Gamosworebis_Bolo}</TableCell>
                                            <TableCell
                                                className="old-objects-cell">{item.samartlebrivi_Reagireba_Sanqcia}</TableCell>
                                            <TableCell
                                                className="old-objects-cell">{item.momdevno_Perioduli_Inspeqtirebis_Vada}</TableCell>
                                            <TableCell
                                                className="old-objects-cell">{item.informacia_Obieqtze_Momxdari_Avariis_da_Ubeduri_Shemtxvevis_Shesaxeb}</TableCell>
                                            <TableCell
                                                className="old-objects-cell">{item.obieqtis_Nebaratvis_N_an_Shesabamisi_Aqtis_N}</TableCell>
                                            <TableCell className="old-objects-cell">{item.shenishvna}</TableCell>
                                            <TableCell
                                                style={{position: 'sticky', right: 0, background: 'white', zIndex: 2}}
                                                className="old-objects-cell">
                                                <div style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    gap: 10
                                                }}>
                                                    <div>
                                                        <Tooltip title="ობიექტის გადატანა უწყებრივ რეესტრში">
                                                            <div>
                                                                <MdOpenInNew style={{cursor: 'pointer'}}
                                                                             className="file-icon preview-icon"
                                                                             onClick={() => openObject(item.id)}/>
                                                            </div>
                                                        </Tooltip>
                                                    </div>
                                                    <div>
                                                        <Tooltip title="ობიექტის წაშლა">
                                                            <div>
                                                                <IoMdTrash
                                                                    className="file-icon delete-icon"
                                                                    onClick={(event) => {
                                                                        event.stopPropagation();
                                                                        setIsDeleteConfirmModalOpen(true);
                                                                        setCurrentObjectId(item.id);
                                                                    }}
                                                                />
                                                            </div>
                                                        </Tooltip>
                                                    </div>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>

                            </Table>
                        </TableContainer>
                    )}

                    <Pagination
                        count={totalPages}
                        page={page}
                        onChange={handlePageChange}
                        className="oldobjects-pagination"
                    />
                    <ConfirmationModal
                        isOpen={isDeleteConfirmModalOpen}
                        onRequestClose={() => setIsDeleteConfirmModalOpen(false)}
                        onConfirm={handleDeleteConfirm}
                        modalText={`დარწმუნებული ხართ? წაშლის შემთხვევაში ჩანაწერის აღდგენა შეუძლებელი იქნება!`}
                    />
                    {alert.message && (
                        <CustomAlert
                            message={alert.message}
                            type={alert.severity}
                            onClose={() => setAlert({message: '', severity: 'info'})}
                        />
                    )}
                </div>
            )}
        </div>
    );
};

export default OldObjects;
